const translations = {
    description: '{{name}} — total across products: {{total}} lb a.i./acre',
    exceedsCapBadge: 'Exceeds season cap',
    title: 'Same active ingredient in multiple products'
};

export default translations;
